import { Link as RouterLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import get from 'lodash/get'
import Button from '@mui/material/Button'
import { useTeam } from '../../../../contexts/TeamContext'
import { useServices } from '../../../../contexts/ServicesContext'
import ServicesList from '../../../../shared/components/ServicesList'
import FlexColumn from "../../../../shared/components/layouts/FlexColumn.jsx";
import Flex from "../../../../shared/components/layouts/Flex.jsx";

function ProjectServicesTab({ project }) {
  const { team } = useTeam()
  const { servicesByProjectId } = useServices()
  const services = get(servicesByProjectId, project.id, [])

  return (
    <FlexColumn gap={2}>
      <Flex fullWidth justifyContent="flex-end">
        <Button
          component={RouterLink}
          to={`/teams/${team.slug}/docker/projects/${project.slug}/services/new`}
          variant="outlined"
          size="small"
        >
          <FormattedMessage id="dockerServices.createButton" />
        </Button>
      </Flex>
      <ServicesList services={services} project={project} />
    </FlexColumn>
  )
}

export default ProjectServicesTab
